import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  deliveryApi,
  type DeliverySlotPayload,
} from "@/lib/admin-api/delivery";

// ---------------------------------------------------------------------------
// Query key
// ---------------------------------------------------------------------------

const SLOTS_KEY = "admin-delivery-slots";

// ---------------------------------------------------------------------------
// Hooks
// ---------------------------------------------------------------------------

export function useDeliverySlots() {
  return useQuery({
    queryKey: [SLOTS_KEY],
    queryFn: () => deliveryApi.slots.list(),
    staleTime: 30_000,
  });
}

export function useCreateDeliverySlot() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: DeliverySlotPayload) =>
      deliveryApi.slots.create(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SLOTS_KEY] });
    },
  });
}

export function useUpdateDeliverySlot() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: Partial<DeliverySlotPayload>;
    }) => deliveryApi.slots.update(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SLOTS_KEY] });
    },
  });
}

export function useDeleteDeliverySlot() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deliveryApi.slots.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SLOTS_KEY] });
    },
  });
}
